<template>
  <div class="bottom-safe" :style="{ 'padding-top': offsetHeight + 'px' }">
    <van-nav-bar
      v-if="prevFullPath"
      :fixed="true"
      title=""
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      ref="navBar"
    />
    <EpisodeHead
      :cover-id="episode.cover"
      :title="episode.title"
      :created="episode.created"
      :seconds="episode.seconds"
      :premium="episode.premium"
      :has-audios="hasAudios"
      :has-videos="hasVideos"
    />
    <div class="block" v-if="false">
      <PeopleList
        role="host"
        :peoples="['大肠', '小明']"
      />
    </div>
    <div class="block" v-if="false">
      <PeopleList
        role="guest"
        :peoples="['Tina']"
        label="双双是像从古典画册里走下来的姑娘，但却没有任何娇羞，保守；对人，对己，对情，对事，落落大方，敢爱敢恨，这样的双子座姑娘，你能懂吗？"
      />
    </div>
    <div class="block">
      <Description
        :content="episode.description"
      />
    </div>
    <div class="block">
      <Photos
        :img-ids="episode.images"
      />
    </div>
    <action-bar
      :episodeId="episode.id"
      :xcx-code="episode.xcx_code"
      :premium="episode.premium"
      :showSlug="episode.show"
      :commentsCount="commentsCount"
      v-on:comment-created="commentCreated"
    />
  </div>
</template>

<script>
  import store from '../store/index'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import EpisodeHead from './episode-head.vue'
  import PeopleList from './people-list.vue'
  import Photos from './photos.vue'
  import Description from './description.vue'
  import ActionBar from './action-bar.vue'
  Vue.use(NavBar)
  // import axios from 'axios'

  export default {
    name: "EpisodeDetail",
    components: {
      EpisodeHead,
      PeopleList,
      Photos,
      Description,
      ActionBar,
    },
    data () {
      return {
        prevFullPath: '',
        episode: {},
        hasAudios: false,
        hasVideos: false,
        activeNames: ['description'],
        commentsCount: 0,
        offsetHeight: 0
      }
    },
    computed: {
    },
    methods: {
      commentCreated () {
        this.commentsCount += 1
      },
      onClickLeft() {
        store.commit("clearPrevFullPath")
        this.$router.replace({
          path: this.prevFullPath
        })
      }
    },
    watch: {
      episode (value) {
        // value: episode
        if (value.audios.length > 0) {
          this.hasAudios = true
        } else {
          this.hasAudios = false
        }
        if (value.videos.length > 0) {
          this.hasVideos = true
        } else {
          this.hasVideos = false
        }
      }
    },
    mounted () {
      let that = this
      if (store.state.prevFullPath) {
        that.prevFullPath = store.state.prevFullPath
        if (store.state.prevFullPath) {
          that.$nextTick(function() {
            that.offsetHeight = that.$refs.navBar.$el.offsetHeight
          })
        }
      }
      let episodeId = this.$route.params.episodeId
      that.$api.episode.detail(episodeId).then(res => {
        that.episode = res.data
        that.commentsCount = res.data.comments_count
      })
      that.$api.history.create({episode:episodeId}).then(res => {
        window.console.log("创建播放记录")
        window.console.log(res)
      })
    }
  }
</script>

<style lang="css" scoped>
  .block{
    margin-top: 10px;
  }
</style>
